import axios from 'axios';

// Configuración del API según el entorno
const API_BASE_URL = 'https://revive-back.vercel.app/api/'; //solo para desplegar
//const API_BASE_URL = 'http://localhost:8000/api/';
 // Desarrollo

const api = axios.create({
    baseURL: API_BASE_URL,
});

// Agregar token automáticamente si existe
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Agregar sede headers si están disponibles en el contexto
    const selectedSedes = localStorage.getItem('selectedSedes');
    if (selectedSedes) {
        try {
            const sedes = JSON.parse(selectedSedes);
            if (sedes.length > 0) {
                if (sedes.length === 1) {
                    // Una sola sede: usar X-Sede-ID
                    config.headers['X-Sede-ID'] = sedes[0].id;
                } else {
                    // Múltiples sedes: usar X-Sedes-Selected
                    config.headers['X-Sedes-Selected'] = sedes.map(sede => sede.id).join(',');
                }
            }
        } catch (error) {
            console.warn('Error parsing selectedSedes:', error);
        }
    }
    
    return config;
});

// Manejar errores de autenticación
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                const refreshToken = localStorage.getItem('refresh');
                if (refreshToken) {
                    const response = await axios.post(`${API_BASE_URL}auth/refresh/`, {
                        refresh: refreshToken
                    });
                    
                    const { access } = response.data;
                    localStorage.setItem('access', access);
                    
                    // Reintentar la petición original con el nuevo token
                    originalRequest.headers.Authorization = `Bearer ${access}`;
                    return api(originalRequest);
                }
            } catch (refreshError) {
                // Si el refresh falla, redirigir al login
                localStorage.removeItem('access');
                localStorage.removeItem('refresh');
                localStorage.removeItem('user');
                window.location.href = '/auth/login';
            }
        }
        
        return Promise.reject(error);
    }
);

// Métodos específicos
export const loginUser = async (username, password) => {
    const response = await axios.post(`${API_BASE_URL}auth/login/`, {
      username,
      password,
    });
  
    const { access, refresh } = response.data;
  
    localStorage.setItem("access", access);
    localStorage.setItem("refresh", refresh);
  
    const userResp = await api.get("auth/me/"); // usa api aquí
    const user = userResp.data;
    localStorage.setItem("user", JSON.stringify(user));
  
    return user;
  };
  

export const getCurrentUser = async () => {
    const token = localStorage.getItem("access");
    if (!token) throw new Error("No token available");

    const response = await api.get("auth/me/"); // ⬅️ usa api en vez de axios
    return response.data;
};

const asList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.results)) return payload.results;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
};

export const getTimeSlots = async (sedeId) => {
    const token = localStorage.getItem("access");
    if (!token) throw new Error("No token available");
    if (!sedeId) return [];
    const response = await api.get(`studio/time-slots/?sede_id=${sedeId}&is_active=true`);
    return asList(response.data);
};

export const createTimeSlot = async (timeSlotData) => {
    const token = localStorage.getItem("access");
    if (!token) throw new Error("No token available");
    const response = await api.post('studio/time-slots/', timeSlotData);
    return response.data;
};

export const updateTimeSlot = async (timeSlotId, timeSlotData) => {
    const token = localStorage.getItem("access");
    if (!token) throw new Error("No token available");
    const response = await api.put(`studio/time-slots/${timeSlotId}/`, timeSlotData);
    return response.data;
};

export const deleteTimeSlot = async (timeSlotId) => {
    const token = localStorage.getItem("access");
    if (!token) throw new Error("No token available");
    const response = await api.delete(`studio/time-slots/${timeSlotId}/`);
    return response.data;
};

export default api;
